



























































































































































































































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import {Action, Getter, Mutation} from "vuex-class";
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import {FormRowWings, SelectWings, TimeoutWings, NumberWings, SmsTextInputWings, InputWings, TextareaWings} from 'wings-ui-components';
import { MsgTransports } from '@/store/types';
import { CallTemplateItemImpl } from '@/store/templates/types';
import {cloneDeep} from "lodash";
import {notifyError} from '@/utils/notify-helper';

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {
    GenericTemplate,
    FormRowWings,
    SmsTextInputWings,
    SelectWings,
    TimeoutWings,
    NumberWings,
    InputWings,
    TextareaWings
}})
export default class CallTemplate extends Vue {
  @Ref('genericTemplate') genericTemplate: any;
  @Prop({default: null}) distribution: any;

  @Getter("templateObject") template: any;
  @Mutation('setTemplateObject') setTemplateObject: any

  @Getter("callSounds") callSoundsList: any;
  @Getter("ivrMenu") ivrMenuList: any;
  @Action("getCallSounds") actionGetCallSounds: any;
  @Action("getIvrMenu") actionGetIvrMenu: any;
  @Action("getTemplates") actionGetTemplates: any;
  @Action("getCallSoundsPlay") actionGetCallSoundsPlay: any;

  private transport = MsgTransports.CALL;
  private templateObject = new CallTemplateItemImpl();
  private typeList = ['ivrmenu', 'text', 'file']
  private is_repeat: boolean = false
  private is_redirect: boolean = false
  private is_redirect_dtmf: boolean = false
  private is_sms: boolean = false
  private is_sms_dtmf: boolean = false
  private is_retry: boolean = false
  private callKeysList = ['', '0','1','2','3','4','5','6','7','8','9','*','#']
  private smsTemplatesList = []
  private tts = '';
  private isShowSMSBlock: boolean = true;

  created() {
    this.setTemplate()
    if (sessionStorage.getItem(this.storageItemName()) && sessionStorage.getItem(this.storageItemName()) !== 'undefined') {
      this.setTemplateObject(JSON.parse(sessionStorage.getItem(this.storageItemName()) || ''))
    }
  }

  @Watch('$route.params.id', {immediate: true})
  onRouteIdChange(val: string, oldVal?: string) {
    if (val) {
      this.setTemplate()
    }
  }

  setTemplate() {
    this.setTemplateObject(cloneDeep(this.templateObject))
  }

  get getFile() {
    const file =  this.callSoundsList.find((item: any) => item.fileId == this.template.message)
    return file ?? {name: '', patch: ''}
  }

  onLoadTemplate(template: any) {
    if (this.template.maxRepeatCount || this.template.repeatDtmf) this.is_repeat = true
    if (this.template.callRedirectDtmf || this.template.redirectNumber) {
      this.is_redirect = true
      this.is_redirect_dtmf = !!this.template.callRedirectDtmf
    }
    if (this.template.sendSmsDtmf || this.template.smsTemplateId) {
      this.is_sms = true
      this.is_sms_dtmf = !!this.template.sendSmsDtmf
    }
    if (this.template.maxRetryCount || this.template.retryInterval) this.is_retry = true
    this.$emit('onLoadTemplate', template)
  }

  @Watch('template.payloadType', {immediate: true})
  async onChangeType(val: string, oldVal?: string) {
    if (val && val !== oldVal){
      try {
        if (val == 'ivrmenu') this.actionGetIvrMenu()
        if (val == 'file') this.actionGetCallSounds()
        if (val == 'text' && this.template.message) this.getCallSoundsPlayLink()
        if (val == 'file' || val == 'text') {
          this.smsTemplatesList = await this.actionGetTemplates({filter: {status: 'Active'}, transport: 'call'})
        }
      } catch(error) {
        let errorCode = parseInt(error.response.data.errorCode);
        if (errorCode === 24) {
          this.isShowSMSBlock = false;
        } else {
          notifyError(error)
        }
      }
    }
  }

  onChangeMessage(e: any) {
    this.getCallSoundsPlayLink()
  }

  async getCallSoundsPlayLink() {
    try {
      const data = await this.actionGetCallSoundsPlay({voiceTypeId: 1, message: this.template.message})
      if (data?.fileLink) this.tts = data?.fileLink
    } catch(error) {
      notifyError(error);
    }
  }

  @Watch('is_repeat', {immediate: true})
  onChangeIsRepeat(val?: boolean) {
    if (!val) {
      this.template.maxRepeatCount = null;
      this.template.repeatDtmf = null;
    }
  }

  @Watch('is_redirect', {immediate: true})
  onChangeIsRedirect(val?: boolean) {
    if (!val) {
      this.is_redirect_dtmf = false;
      this.template.callRedirectDtmf = null;
      this.template.redirectNumber = null;
    }
  }

  @Watch('is_redirect_dtmf', {immediate: true})
  onChangeIsRedirectDtmf(val?: boolean) {
    if (!val) {
      this.template.callRedirectDtmf = null;
    }
  }

  @Watch('is_sms', {immediate: true})
  onChangeIsSms(val?: boolean) {
    if (!val) {
      this.is_sms_dtmf = false;
      this.template.sendSmsDtmf = null;
      this.template.smsTemplateId = null;
    }
  }

  @Watch('is_sms_dtmf', {immediate: true})
  onChangeIsSmsDtmf(val?: boolean) {
    if (!val) {
      this.template.sendSmsDtmf = null;
    }
  }

  @Watch('is_retry', {immediate: true})
  onChangeIsRetry(val?: boolean) {
    if (!val) {
      this.template.maxRetryCount = null;
      this.template.retryInterval = null;
    }
  }

  storageItemName():string {
    return this.$options.name || '';
  };

  beforeRouteLeave(to:any, from:any, next:any) {
    if (to.name == 'distribution_template_call_sound') {
      sessionStorage.setItem(this.storageItemName(), JSON.stringify(this.template))
      next()
    } else {
      this.genericTemplate.beforeLeave(to,from,next)
    }
  }
}
